import moment from "moment";
import { EMARPOLDocuments } from "../../marpol/@types";
import { TBiofouling2Place } from "../@types";
import {
	EBFL2RecordCode,
	EBFL2RecordState,
	TBFL2CommonData,
	TBFL2CommonFields,
} from "../@types";

export type TBFL2B1Item1 = {
	descriptionOfAnyObservedReduction: string;
};

export type TBFL2B1Item2 = {
	descriptionOfAnyOperationBeyondExpected: string;
};

export type TBFL2B1Item3 = {
	contingencyActions: string;
};

export type TBFL2B1Item4 = {
	locationWhereAnyAFCMaintenance: string;
};

export type TBFL2B1Item5 = {
	descriptionOfAnyAFC: string;
};

export type TBFL2B1Item6 = {
	referenceToAnySupportingData: string;
	referenceAttachment: string;
};

export type TBFL2B1 = TBFL2CommonFields &
	TBFL2CommonData & {
		id: string;
		recordCode: EBFL2RecordCode.BFL2B1;
		item1: TBFL2B1Item1;
		item2: TBFL2B1Item2;
		item3: TBFL2B1Item3;
		item4: TBFL2B1Item4;
		item5: TBFL2B1Item5;
		item6: TBFL2B1Item6;
	};

export type TBFL2B = TBFL2B1;

const BFL2B_DEFAULTS: {
	B1: TBFL2B1;
} = {
	B1: {
		id: "",
		_rev: "",
		marpolType: EMARPOLDocuments.BFL2,
		state: EBFL2RecordState.IDLE,
		selectedDate: moment().format("YYYY-MM-DD"),
		remarks: "",
		item1: {
			descriptionOfAnyObservedReduction: "",
		},
		item2: {
			descriptionOfAnyOperationBeyondExpected: "",
		},
		item3: {
			contingencyActions: "",
		},
		item4: {
			locationWhereAnyAFCMaintenance: "",
		},
		item5: {
			descriptionOfAnyAFC: "",
		},
		item6: {
			referenceToAnySupportingData: "",
			referenceAttachment: " ",
		},
		recordCode: EBFL2RecordCode.BFL2B1,
	},
};

export { BFL2B_DEFAULTS };
